// extracted by mini-css-extract-plugin
export var gif = "_jk-0";